import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import './PopUpRemove.scss';
import { translate } from '../../../../../I18n/i18n';

interface PopUpRemoveProps extends WithTranslation{
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;  // Aquí manejamos el "submit" para la eliminación
}

const PopUpRemove: React.FC<PopUpRemoveProps> = ({ show, onClose, onSubmit, t }) => {
  if (!show) return null;  // Si no se debe mostrar, no renderizamos nada

  return (
    <div className="popupRemove">
      <div className="popupRemove-overlay" onClick={onClose}></div>
      <div className="popupRemove-content">
        <div className="popupRemove-header">
          <p>{translate(t, 'common.TR_DELETE_TEXT_LABEL')}</p>
        </div>
        <div className="popupRemove-actions">
          <button onClick={onSubmit} className="btn btn-danger">{translate(t, 'common.TR_DELETE_LABEL')}</button>
          <button onClick={onClose} className="btn btn-secondary">{translate(t, 'common.TR_CANCEL_LABEL')}</button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PopUpRemove);
